<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "INDEX_PAGE",
  data() {
    return {};
  },

  created() {},
  methods: {},
};
</script>